import { rgba } from 'polished';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';
import { Heading1 } from '../../../shared/Typography';

export const StyledHero = styled.div`
  background-color: ${color('midnight_900')};
  background-image: linear-gradient(
      ${rgba('#1f1d26', 0.75)},
      ${rgba('#1f1d26', 0.75)}
    ),
    url('${getPublicPath('/images/stateSector/hero-bg.gif')}');
  background-size: cover;
  padding: ${spacing('xl4')} ${spacing('md')} ${spacing('xl6')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    padding-top: ${spacing('xl6')};
    padding-bottom: ${spacing('xl7')};
  }

  &::after {
    background-image: ${() =>
      `url('${getPublicPath('/images/stateSector/curve-bg.svg')}')`};
    content: '';
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    display: block;
    width: calc(100% + ${spacing('md')});
    height: 8rem;
    position: absolute;
    bottom: 0;
    left: -${spacing('md')};
    right: -${spacing('md')};
  }
`;

export const StyledHeroCta = styled.div`
  text-align: center;
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  text-align: center;
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;
`;

export const StyledHeroTitle = styled(Heading1)`
  color: ${color('mint_500')};
  margin-bottom: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};
  font-size: ${fontSize('xl5')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl6')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl7')};
  }

  span {
    font-family: ${fontFamily('sans')};
    font-size: ${fontSize('md')};
    line-height: 1;
    color: ${color('text_white')};
    text-transform: uppercase;
    font-weight: ${fontWeight('extraBold')};
    letter-spacing: 0.35em;

    @media (min-width: ${screen('md')}) {
      font-size: ${fontSize('lg')};
    }
  }
`;
